import { FC, useState } from 'react';
import { OrganizationModalsContext, ModalState } from './OrganizationModalsContext';

export const OrganizationModalsContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [modalState, showModal] = useState<ModalState | null>(null);
  const hideModal = () => showModal(null);

  return (
    <OrganizationModalsContext.Provider
      value={{
        showModal,
        hideModal,
        modalState,
      }}
    >
      {children}
    </OrganizationModalsContext.Provider>
  );
};
